module.exports = __webpack_public_path__ + "media/img/vca/whatsapp-e382eb9bf9d735cd9d527c933e058db3.png";